// Google Sheets API integration for form submissions
// Note: This requires Google Apps Script web apps to be set up for each spreadsheet

const CONTACT_FORM_SCRIPT_URL = 'https://script.google.com/macros/s/YOUR_CONTACT_SCRIPT_ID/exec';
const TEAM_APPLICATION_SCRIPT_URL = 'https://script.google.com/macros/s/YOUR_TEAM_SCRIPT_ID/exec';

// Simulate network delay for development
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export interface ContactFormData {
  name: string;
  email: string;
  phone: string;
  message: string;
}

export interface TeamApplicationData {
  name: string;
  email: string;
  phone: string;
  position: string;
  experience: string;
}

export const googleSheetsApi = {
  async submitContactForm(data: ContactFormData): Promise<void> {
    await delay(500); // Simulate network delay

    const formData = new FormData();
    formData.append('Name', data.name);
    formData.append('Email', data.email);
    formData.append('Phone', data.phone);
    formData.append('Message', data.message);
    formData.append('Timestamp', new Date().toISOString());

    try {
      const response = await fetch(CONTACT_FORM_SCRIPT_URL, {
        method: 'POST',
        body: formData,
        mode: 'no-cors', // Required for Google Apps Script
      });

      // Note: With no-cors mode, we can't read the response
      // We assume success if no error is thrown
      console.log('Contact form submitted successfully');
    } catch (error) {
      console.error('Error submitting contact form:', error);
      throw new Error('Failed to submit contact form. Please try again.');
    }
  },

  async submitTeamApplication(data: TeamApplicationData): Promise<void> {
    await delay(500); // Simulate network delay

    const formData = new FormData();
    formData.append('Name', data.name);
    formData.append('Email', data.email);
    formData.append('Phone', data.phone);
    formData.append('Position', data.position);
    formData.append('Experience', data.experience);
    formData.append('Timestamp', new Date().toISOString());

    try {
      const response = await fetch(TEAM_APPLICATION_SCRIPT_URL, {
        method: 'POST',
        body: formData,
        mode: 'no-cors', // Required for Google Apps Script
      });

      // Note: With no-cors mode, we can't read the response
      // We assume success if no error is thrown
      console.log('Team application submitted successfully');
    } catch (error) {
      console.error('Error submitting team application:', error);
      throw new Error('Failed to submit application. Please try again.');
    }
  },
};
